// extracted by mini-css-extract-plugin
module.exports = {"customDropdownContainer":"footer-dropdown_customDropdownContainer__C9__L","globeIcon":"footer-dropdown_globeIcon__M308T","customDropdown":"footer-dropdown_customDropdown__up_PY"};